// Sentraliserte farger og tema for appen
// Endre fargene her for å påvirke hele appen

export const theme = {
    // Primærfarge (brukt på header, knapper, lenker)
    primaryColor: '#af4522b4',
    primaryHover: '#1b5e20',
    
    // Sekundære farger
    dangerColor: '#d32f2f',
    dangerHover: '#b71c1c',
    warningColor: '#ff9800',
    
    // Nøytrale farger
    backgroundColor: '#f5f5f5',
    cardBackground: '#ffffff',
    borderColor: '#ddd',
    
    // Tekstfarger
    textPrimary: '#333',
    textSecondary: '#666',
    textMuted: '#999',
    
    // Status
    successColor: '#4caf50',
    errorBackground: '#ffebee',
    errorText: '#d32f2f',
};
